import { Typography, Box, Grid, List, ListItem, Stack, Divider } from "@mui/material"

const Preview4 = ({fieldValues, selectedColor, fullHeight=false, page='preview', sections}) =>{
    let headerFontSize ='30px',subHeaderFontSize ='16px', headerPadding = 5, contentpadding = 3,subContentPadding = 1, titleFontSize = '20px', subTitleFontSize='18px', contentFontSize = '16px';
    if(page === 'template'){
        headerFontSize = '16px'
        subHeaderFontSize = '10px'
        headerPadding = 2
        contentpadding = 1
        subContentPadding = 0.5
        titleFontSize = '12px'
        subTitleFontSize = '10px'
        contentFontSize = '10px'
    }

    const getobjectiveContent = (index) =>{
        return <Grid key={'Objective'} item xs={12} px={subContentPadding}>
        {index != 1 ? <Typography sx={{fontSize: titleFontSize, fontWeight: 600,color: selectedColor?.[0] || '#000', textAlign:'center'}} >Objective</Typography> : ''}
        <Typography sx={{fontSize:contentFontSize}}>{fieldValues.objective}</Typography>
    </Grid>
    }
    const geteducationContent = () =>{
        return <Grid item key={'education'} xs={12} p={subContentPadding}>
        <Typography sx={{fontSize: titleFontSize, fontWeight: 600,color: selectedColor?.[0] || '#000', textAlign:'center'}} >Education</Typography>
        <Stack spacing={1} >
            {fieldValues.education.map((edu, index)=>{
                return  <Grid key={index}><Typography sx={{fontSize:subTitleFontSize}}><strong>{edu.degree} {edu.field_of_study}</strong>, {edu.start_date[0]}-{edu.end_date[0]}</Typography>
            <Typography sx={{fontSize:contentFontSize}}>{edu.school_name}, {edu.school_location}</Typography></Grid>
            })}
       </Stack> 
    </Grid>
    }
    const getexperienceContent = () =>{
        return <Grid item xs={12} key={'experience'} p={subContentPadding}>
        <Typography sx={{fontSize: titleFontSize, fontWeight: 600,color: selectedColor?.[0] || '#000', textAlign:'center'}}>Experience</Typography>
        <Stack spacing={1} >
                {fieldValues.experience.map((exp, index)=>{
                    return <><Grid key={index} container xs={12}>
                            <Grid xs={8}>
                                <Typography sx={{fontSize:contentFontSize}}><strong>{exp.job_title} | {exp.employer}</strong></Typography>
                            </Grid>
                            <Grid xs={4}>
                                <Typography fontStyle={'italic'} sx={{float: 'right', fontSize:contentFontSize}}>{exp.start_date[0]} {exp.start_date[1]}-{exp.end_date[0]} {exp.end_date[1]}</Typography>
                            </Grid>
                        </Grid>
                        {exp.description ? <Typography sx={{fontSize:contentFontSize}} dangerouslySetInnerHTML={{__html: exp.description?._cache?.html ? exp.description?._cache?.html.toString('html') : exp.description.toString('html')}}></Typography> : ''}
                </>
                })}
        </Stack> 
    </Grid>
    }
    const getskillsContent = () =>{
        return <Grid item xs={12} key={'skills'} p={subContentPadding}>
        <Typography sx={{fontSize: titleFontSize, fontWeight: 600,color: selectedColor?.[0] || '#000', textAlign:'center'}}>Skills</Typography>
        <List disablePadding>
            {fieldValues.skills.map((skill, index)=>{
                    return   <ListItem key={index} disablePadding>
                    <Typography sx={{fontSize:contentFontSize}} >{skill.skill}</Typography>
                </ListItem>
                })}
        </List>
    </Grid>
    }
    const getotherContent = () =>{
        return fieldValues.other.map((other, index)=>{
            return <Grid key={index} item xs={12} p={subContentPadding}>
                {other.title ? <Typography sx={{fontSize: titleFontSize, fontWeight: 600,color: selectedColor?.[0] || '#000', textAlign:'center'}} >{other.title}</Typography> :''}
                {other.content ? <Typography  sx={{fontSize:contentFontSize}} dangerouslySetInnerHTML={{__html: other.content?._cache?.html ? other.content?._cache?.html.toString('html') : other.content.toString('html')}}></Typography> : ''}
            </Grid>
        })
    }

    return <Box sx={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", flexGrow:1,  width:"100%", height: fullHeight ? "100%" : 'auto' }} >
        <Grid item p={headerPadding} xs={12} textAlign={'center'}>
            <Typography sx={{fontSize:headerFontSize, fontWeight:'600', color: selectedColor?.[0] || '#000'}}>{fieldValues.f_name || 'John'} {fieldValues.l_name}</Typography>
            <Typography sx={{fontSize:subHeaderFontSize, color:'#606767'}}>{fieldValues.designation || 'Software Engineer'}</Typography>
            <Divider sx={{borderColor: "#000" }}/>
            <Grid container  xs={12} >
                <Grid container xs={5} gap={1} display={'flex'}>
                    <Typography sx={{fontSize:subHeaderFontSize}}>{fieldValues.city || 'Chennai'}, {fieldValues.state || 'Tamilnadu'}</Typography>
                </Grid>
                <Grid container xs={4} gap={1}>
                    <Typography sx={{fontSize:subHeaderFontSize}}>{fieldValues.email || 'xxx@gmail.com'}</Typography>
                </Grid>
                <Grid container xs={3} gap={1}>
                    <Typography sx={{fontSize:subHeaderFontSize}}>{fieldValues.phone || '9876543210'}</Typography>
                </Grid>   
            </Grid>
        <Divider sx={{borderColor: "#000" }}/>
        </Grid>
            <Grid container xs={12} px={contentpadding}>  
            {sections?.map((section, index)=>{
                    if(section === 'Objective'){
                        return fieldValues.objective ? getobjectiveContent(index) : ''
                    }else if(section === 'Education'){
                        return fieldValues.education.length ? geteducationContent() : ''
                    }else if(section === 'Experience'){
                        return fieldValues.experience.length ? getexperienceContent() : ''
                    }else if(section === 'Skills'){
                        return fieldValues.skills.length ? getskillsContent() : ''
                    }else if(section === 'Other'){
                        return fieldValues.other.length && fieldValues.other[0].title ? getotherContent() : ''
                    }
                    return ''
                })
            }
            </Grid>
  </Box>
}

export default Preview4